import * as React from 'react';
import { SVGProps } from 'react';

const FirstPodium = (props: SVGProps<SVGSVGElement>): JSX.Element => {
  const { width, height, ...restProps } = props;
  const gradientA = 'thirdPodiumGradientA';
  const gradientB = 'thirdPodiumGradientB';
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 282 341"
      width={width}
      height={height}
      fill="none"
    >
      <path fill={`url(#${gradientA})`} d="M0 29.749h281.63v310.554H0z" />
      <path
        fill={`url(#${gradientB})`}
        d="M32.274 0h211.222l38.431 30.13H.297L32.274 0Z"
      />
      <defs>
        <linearGradient
          id={gradientA}
          x1={140.815}
          x2={140.815}
          y1={29.749}
          y2={340.303}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={1} stopColor="#FF9800" />
        </linearGradient>
        <linearGradient
          id={gradientB}
          x1={140.819}
          x2={140.819}
          y1={-41.039}
          y2={51.061}
          gradientUnits="userSpaceOnUse"
        >
          <stop offset={0.125} stopColor="#FFD495" />
          <stop offset={1} stopColor="#FF9800" />
        </linearGradient>
      </defs>
    </svg>
  );
};
export default FirstPodium;
